<div class="blockUI blockMsg blockElement block-ui-template">
          <div class="blockui mx-auto"><span>Please wait...</span><span>
            <div class="kt-spinner kt-spinner--v2 kt-spinner--success"></div>
          </span></div>
        </div>